import { useState, useEffect, useCallback } from "react";

const useGetComments = (blogId) => {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchComments = useCallback(async () => {
    if (!blogId) {
      setComments([]);
      return;
    }

    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${baseUrl}/blogs/${blogId}/comments`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || "Failed to fetch comments";
        throw new Error(message);
      }

      // Handle different response structures
      const commentsData = data.data?.comments || data.data || data.results || data.comments || data || [];
      setComments(Array.isArray(commentsData) ? commentsData : []);
      return commentsData;
    } catch (err) {
      setIsError(true);
      setError(err);
      setComments([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, [blogId]);

  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  return { comments, isLoading, isError, error, refetch: fetchComments };
};

export default useGetComments;

